import { useQuery } from "@tanstack/react-query";
import { getEmailPrograms } from "../../services/EmailMonitoringService";

// Comebacks need time to show, so "Today" reads the last 7 days. Shared with
// the tab's summary so both read one cached query.
export function programsRangeDays(days: number) {
  return Math.max(days, 7);
}

export function useEmailPrograms(days: number) {
  const rangeDays = programsRangeDays(days);
  return useQuery({
    queryKey: ["email-programs", rangeDays],
    queryFn: () => getEmailPrograms(rangeDays, 30),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
